module.exports = __webpack_public_path__ + "fonts/EuropeNormal.db21aafc.ttf";